import i18next from 'i18next';
import { initReactI18next, type useTranslation } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { resources, defaultNS, supportedLanguages } from '@/i18n/locales';
import { SUPPORT_EMAIL } from '@/constants';

/** The `t` function as returned by `useTranslation()` — for helpers that
 *  receive it as a parameter. */
export type TFn = ReturnType<typeof useTranslation>['t'];

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    supportedLngs: supportedLanguages,
    fallbackLng: 'en',
    debug: false,
    defaultNS,
    resources,
    // React already escapes rendered values; i18next's own HTML escaping would
    // double-escape interpolations (e.g. a tenant name "A & B" -> "A &amp; B").
    interpolation: {
      escapeValue: false,
      defaultVariables: { supportEmail: SUPPORT_EMAIL }
    }
  });

const syncHtmlLang = (lng: string) => {
  document.documentElement.lang = lng;
};

export function bindHtmlLangToLanguage() {
  i18next.on('languageChanged', syncHtmlLang);
  syncHtmlLang(i18next.language);
}

export default i18next;
